import React from "react"
import {FormGroup} from "react-bootstrap"
import styled, {css} from "styled-components"

export interface FormGroupProps {
  flush?: boolean
}

const StyledFormGroup = styled(({flush, ...rest}) => <FormGroup {...rest} />)<FormGroupProps>`
  .input-group .form-control {
    z-index: auto;
  }

  ${({flush, theme}) => css`
    .input-group-addon {
      background-color: ${theme.colors.utility.white};
      border: 1px solid ${theme.colors.utility.subdued};
    }
    .input-group-addon:first-child {
      border-right: 0;
    }
    .input-group-addon:last-child {
      border-left: 0;
    }
    .form-control:focus + .input-group-addon {
      border: 1px solid ${theme.colors.primary1};
      border-left: 0;
      position: relative;
      z-index: 1;
    }
    .form-control:not(:-webkit-autofill) + .input-group-addon {
      box-shadow: inset 0 1px 1px rgb(0 0 0 / 8%); /* to match bootstrap */
    }
    .form-control:focus:not(:-webkit-autofill) + .input-group-addon {
      box-shadow: 0 0 4px 0 ${theme.colors.primary1};
      clip-path: inset(-${theme.spacing.one} -${theme.spacing.one} -${theme.spacing.one} 0px);
    }
    &.has-error .form-control + .input-group-addon {
      border-color: ${theme.colors.tertiary.r_400} ;
      box-shadow: 0 0 2px 0 ${theme.colors.tertiary.r_400} !important;
    }
    margin-bottom: ${flush ? 0 : theme.spacing.two};
  `}
`

export default StyledFormGroup
